module.exports = __webpack_public_path__ + "static/img/swiper3.db1daa93.png";